<ion-content>
  <div class="ion-align-items-center ion-justify-content-center" [style.height]="'75%'">
    <qrcode [qrdata]="qrData" [errorCorrectionLevel]="'M'" [allowEmptyString]="true" [width]="width"></qrcode>
  </div>
</ion-content>
